module.exports = __webpack_public_path__ + "static/media/rebranding-no-website-img.e6b7eb2e.svg";